import { Publisher } from '@amzn/katal-metrics';
import { METRIC_NAME_MAX_CHAR_LENGTH, MetricType } from 'src/constants/metricConstants';
import { makePublisher } from 'src/metrics/metrics';
import { store } from 'src/store/store';

export const programBasedMetricsPublisher = () => {
  const state = store.getState();
  return makePublisher(state.program.selectedProgram?.toString());
};

/**
 * Returns action publisher to publish metrics with given methodName
 * https://katal.amazon.dev/metrics/getting-started-guide/
 * @param methodName string
 * @returns actionPublisher Publisher
 */
export const getActionPublisherForProgram = (methodName: string) =>
  programBasedMetricsPublisher().newChildActionPublisherForMethod(methodName);

/**
 * Publish metrics with sanitized metric name in cloudwatch using Katal metrics
 * https://katal.amazon.dev/for-developers/metrics/schema/
 * Metric Name schema:
 * Maximum length of 127 characters each
 * Can only contain ASCII letters, numbers, and the period,
 * colon, at-sign, underscore, forward-slash, and dash characters
 * @param actionPublisher Publisher
 * @param metricName string
 * @param value string | number
 * @param type  MetricType
 */
export const publishKatalMetric = (
  actionPublisher: Publisher,
  metricName: string,
  value: string | number,
  metricType: MetricType,
) => {
  const santinizedMetricName = metricName.replace(/[^A-Za-z0-9.:@_/-]/g, '_').substring(0, METRIC_NAME_MAX_CHAR_LENGTH);
  switch (metricType) {
    case MetricType.String: {
      // String values should be 256 characters or less.
      actionPublisher.publishStringTruncate(santinizedMetricName, value as string);
      break;
    }
    case MetricType.Timer: {
      actionPublisher.publishTimerMonitor(santinizedMetricName, value as number);
      break;
    }
    default: {
      actionPublisher.publishCounterMonitor(santinizedMetricName, value as number);
      break;
    }
  }
};
